module.exports = __webpack_public_path__ + "static/repository-9693c2b92d0dff51727ddd49326712c9.png";